import React, { memo } from "react";
import dynamic from "next/dynamic";
import { SearchResultsTypes, SearchTexts } from "../../../utils/constants";
import { useDeviceType } from "@lululemon/ecom-site/src/util/with-device-characteristics";

const StoryCarousel = dynamic(
  () =>
    // @ts-ignore
    import("@lululemon/ecom-story/src/components/story-carousel/story-carousel")
);

interface RecommendationsCarouselProps {
  products: ProdRecommendation["records"];
  searchResultType: string;
  productsType: string;
}
enum ProductType {
  TOP_PRODUCT = "topProd",
  RECENTLY_VIEWED = "recentlyViewed",
}
/**
 * @RecommendationsCarousel for displaying recommendations in a carousel format.
 * @param {RecommendationsCarouselProps} props - The props for the RecommendationsCarousel component.
 * @returns {JSX.Element} JSX element representing the RecommendationsCarousel component.
 */
export const RecommendationsCarousel: React.FC<RecommendationsCarouselProps> =
  memo(({ products, searchResultType, productsType }) => {
    const { deviceType } = useDeviceType();

    if (!products || products.length == 0) {
      return null;
    }

    if (searchResultType === SearchResultsTypes.SEARCH_RESULTS_DEFAULT) {
      return null;
    }

    const recommendationData = {
      title:
        productsType === ProductType.TOP_PRODUCT
          ? SearchTexts.RECOMMENDATION_TITLE
          : productsType === ProductType.RECENTLY_VIEWED
          ? SearchTexts.RECENTLY_VIEWED_TITLE
          : "",
      records: products,
    };

    let maxSlides = 0;
    let customHeadlineClass = "custom-headline lll-text-xsmall";
    let customWrapperClass = "";

    if (
      searchResultType ===
      SearchResultsTypes.SEARCH_RESULTS_PARTIAL_MATCH_LIMITED
    ) {
      maxSlides = 3;
      customHeadlineClass =
        "custom-headline partial-match-limited lll-text-xsmall";
      customWrapperClass = "carousel-wrapper";
    }

    return (
      <div>
        <StoryCarousel
          // @ts-ignore
          isMobileDevice={deviceType.isMobile}
          data={recommendationData}
          maxSlides={maxSlides}
          customHeadlineClass={customHeadlineClass}
          customWrapperClass={customWrapperClass}
          noBackground
          recommendation
        />
      </div>
    );
  });

RecommendationsCarousel.displayName = "RecommendationsCarousel";
